import { render } from "./AuraProcessingCostsHeader.vue?vue&type=template&id=731472db&ts=true"
import script from "./AuraProcessingCostsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraProcessingCostsHeader.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/aura/components/AuraProcessingCostsHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "731472db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('731472db', __exports__)) {
    api.reload('731472db', __exports__)
  }
  
  module.hot.accept("./AuraProcessingCostsHeader.vue?vue&type=template&id=731472db&ts=true", () => {
    api.rerender('731472db', render)
  })

}


export default __exports__